import * as Yup from "yup";

export const BookingAppointmentSchema = Yup.object().shape({
  appointmentTypeId: Yup.object().shape({
    label: Yup.string(),
    value: Yup.number(),
  }),
  member: Yup.array()
    .of(
      Yup.object().shape({
        id: Yup.number(),
        preBooking: Yup.boolean(),
        package: Yup.number().when("preBooking", {
          is: true, // When preBooking is true
          then: Yup.number().nullable(), // Make package optional
          otherwise: Yup.number().required(
            "Please assign packages to all chosen members"
          ), // Require package
        }),
      })
    )
    .min(1, "Please Choose at least one member"),
  trainer: Yup.object().shape({
    label: Yup.string(),
    value: Yup.number(),
  }),
  date: Yup.date().required("Date is required"),
  time: Yup.string().required("Time is required"),
});

export const FormatObjects = (
  data,
  name,
  count = false,
  idName,
  propName = false,
  extraKey = ""
) => {
  if (data && data.length > 0) {
    let arr;

    const addExtra = (item) =>
      extraKey ? { [extraKey]: item[extraKey] } : {};

    if (!propName) {
      arr = data.map((item) => {
        if (!count) {
          if (!idName) return { label: item[`${name}`], value: item.id,...addExtra(item)};
         return { label: item[`${name}`], value: item[`${idName}`],...addExtra(item) };
        } else {
          if (!idName)
            return {
              label: item[`${name}`],
              value: item.id,
              count: item.count || 0,
              ...addExtra(item),
            };

          return {
            label: item[`${name}`],
            value: item[`${idName}`],
            count: item.count || 0,
            ...addExtra(item),
          };
        }
      });
    } else {
      arr = data.map((item) => {
        if (!count) {
          if (!idName)
            return {
              label: item[`${propName}`][`${name}`],
              value: item[`${propName}`].id,
              ...addExtra(item),
            };
          return {
            label: item[`${propName}`][`${name}`],
            value: item[`${propName}`][`${idName}`],
            ...addExtra(item),
          };
        } else {
          if (!idName)
            return {
              label: item[`${propName}`][`${name}`],
              value: item[`${propName}`].id,
              count: item.count || 0,
              ...addExtra(item),
            };
          return {
            label: item[`${propName}`][`${name}`],
            value: item[`${propName}`][`${idName}`],
            count: item.count || 0,
            ...addExtra(item),
          };
        }
      });
    }
    return arr;
  } else return [];
};
